module.exports = __webpack_public_path__ + "static/produce-7e25a70d74169676bde08d3234277723.png";